import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { ChecklistFormInputs } from './ChecklistFormInputs';

export function ChecklistsCreatePage() {
  return (
    <MoonstarCreate redirect="list">
      <MoonstarCreateForm>
        <ChecklistFormInputs />
      </MoonstarCreateForm>
    </MoonstarCreate>
  );
}
